import {Reducer} from "redux";
import {IApplicationState} from "../types";
import {fromJS} from "immutable";
import lineDistance from "@turf/line-distance";
import generateCurvature from "../../utils/generate-curvature";

const measureLayerKey = 'CONO_MEASURE';

// takes a list of points and turns them into labeled measurement layers
// should reset old measurement layers (or unset if list is empty)
//

const baseLineFeature: GeoJSON.Feature = {
    "type": "Feature",
    "geometry":
        {
            "type":"LineString",
            "coordinates":[
                [-105.02824974375814,38.87349975106513],
                [38.893718902196156,-104.96209574061963]
            ]
        },
    "properties":{
        "label":"8046.202122008868 miles"
    }
};

const reducer: Reducer<IApplicationState['map']> = (state, action) => {
    console.log(action);
    const {coordinates} = action.payload;
    let mapStyle = state?.mapStyle;
    const measureLayerIds: string[] = [];
    // if (coordinates.length === 0) {
    //     return {...state, mapStyle};
    // }
    let sources = mapStyle?.get('sources');
    let layers = mapStyle?.get('layers')
        .filter((layer: any) => {
            return layer.get('id').indexOf(measureLayerKey) === -1;
        });
    let layersToRemove = mapStyle?.get('layers')
        .filter((layer: any) => {
            return layer.get('id').indexOf(measureLayerKey) !== -1;
        });
    layersToRemove.forEach((layer: any) => {
        sources = sources.delete(layer.id);
    });
    while (coordinates.length > 1) {
        const n = coordinates.length - 1;
        const coord1 = coordinates.pop();
        const coord0 = coordinates[coordinates.length - 1];
        const feature = {
            ...baseLineFeature,
            geometry: {
                ...baseLineFeature.geometry,
                coordinates: [coord0, coord1]
            }
        };
        // @ts-ignore
        const dist = lineDistance(feature, 'miles');
        feature.properties = {label: dist.toFixed(2) + ' miles'};
        const newLayers: any = generateCurvature(feature, 'linear');
        // eslint-disable-next-line no-loop-func
        newLayers.forEach((l: any, i: number) => {
            const name = `${measureLayerKey}_${n}_${i}`;
            l.id = name;
            sources = sources.set(name, fromJS(l.source));
            l.source = name as any;
            layers = layers.push(fromJS(l));
            measureLayerIds.push(name);
        });
    }
    mapStyle = mapStyle?.set('layers', layers);
    mapStyle = mapStyle?.set('sources', sources);
    return {...state, mapStyle, measureLayerIds} as IApplicationState['map'];
};


export { reducer as createMeasurementLayer };
